import { useId } from 'react';
import { cn } from '@/utils/cn';

interface ProviderCardGlowProps {
  className?: string;
}

const CARD_WIDTH = 178;
const CARD_HEIGHT = 80;
const CARD_RADIUS = 12;

export function ProviderCardGlow({ className }: ProviderCardGlowProps) {
  const rawId = useId();
  const safeId = rawId.replace(/:/g, '');

  const paint0DefaultId = `provider-card-paint0-default-${safeId}`;
  const paint1DefaultId = `provider-card-paint1-default-${safeId}`;
  const paint0HoverId = `provider-card-paint0-hover-${safeId}`;
  const paint1HoverId = `provider-card-paint1-hover-${safeId}`;

  return (
    <div className={cn('group relative', className)}>
      <svg
        width="178"
        height="80"
        viewBox="0 0 178 80"
        preserveAspectRatio="none"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="w-full h-full"
      >
        <rect width={CARD_WIDTH} height={CARD_HEIGHT} rx={CARD_RADIUS} fill="#231333" />
        <g className="transition-opacity duration-300 group-hover:opacity-0">
          <rect width={CARD_WIDTH} height={CARD_HEIGHT} rx={CARD_RADIUS} fill={`url(#${paint0DefaultId})`} />
          <rect width={CARD_WIDTH} height={CARD_HEIGHT} rx={CARD_RADIUS} fill={`url(#${paint1DefaultId})`} />
        </g>
        <g className="opacity-0 transition-opacity duration-300 group-hover:opacity-100">
          <rect width={CARD_WIDTH} height={CARD_HEIGHT} rx={CARD_RADIUS} fill={`url(#${paint0HoverId})`} />
          <rect width={CARD_WIDTH} height={CARD_HEIGHT} rx={CARD_RADIUS} fill={`url(#${paint1HoverId})`} />
        </g>
        <defs>
          <radialGradient
            id={paint0DefaultId}
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(124 13.5) rotate(56.6336) scale(98.1835 76.4782)"
          >
            <stop stopColor="#4E256E" />
            <stop offset="1" stopColor="#4E256E" stopOpacity="0" />
          </radialGradient>
          <radialGradient
            id={paint1DefaultId}
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(25 80) rotate(-75.1414) scale(76.0427 172.535)"
          >
            <stop stopColor="#7C243D" />
            <stop offset="1" stopColor="#701F6F" stopOpacity="0" />
          </radialGradient>
          <radialGradient
            id={paint0HoverId}
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(124 13.5) rotate(56.6336) scale(98.1835 97.4094)"
          >
            <stop stopColor="#68269C" />
            <stop offset="1" stopColor="#6D2BA1" stopOpacity="0" />
          </radialGradient>
          <radialGradient
            id={paint1HoverId}
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(25 80) rotate(-73.8398) scale(91.6201 207.879)"
          >
            <stop stopColor="#8D2140" />
            <stop offset="1" stopColor="#8E248C" stopOpacity="0" />
          </radialGradient>
        </defs>
      </svg>
    </div>
  );
}
